import React, {CSSProperties} from "react"
import {useTranslation} from "react-i18next"

import {IonContent, IonPage, IonProgressBar, useIonViewWillEnter} from "@ionic/react"

import ItemPageHeader from "../../components/common/Headers/ItemPageHeader"
import Message from "../../components/common/Message";

import {useLockingSystems} from '../../contexts/LockingSystemContext'
import {useAuth} from "../../contexts/AuthContext"

interface pageProps {
    fetchItems:       any;
    useItems:         () => any;
    itemId:           string;
    segment:          string;
    items:            any[] | undefined;
    itemType:         string;
    itemTypeName:     string;
    itemTypeUrl:      string;
    pageHeaderTitle?: string;

    ItemForm?:                     any
    ItemNotFound?:                 any
    ItemView:                      any
    KeysList?:                     any
    LocksList?:                    any
    LockingSystemPermissionsList?: any
    LockingSystemZonesList?:       any
    PeopleList?:                   any
    DataSourceSyncList?:           any
    TimeLimitDataList?:            any
}

const PageItem: React.FC<pageProps> = ({
    fetchItems, items, useItems,
    itemId, segment, itemType, itemTypeName, itemTypeUrl, pageHeaderTitle,
    ItemForm, ItemNotFound, ItemView, KeysList, LocksList,
    LockingSystemPermissionsList, LockingSystemZonesList, PeopleList,
    DataSourceSyncList, TimeLimitDataList
}) => {
    const {t} = useTranslation()
    const {isAccountAdmin} = useAuth()

    // make sure lockingSystems are loaded
    const { fetchItems: fetchLockingSystems } = useLockingSystems()

    const {inProgress, closeMessage, message, fetchItem, fetchItemOnBlocklist} = useItems()

    const [item, setItem] = React.useState<any>(undefined)

    const [selectedSegment, setSelectedSegment] = React.useState<string>('item')

    useIonViewWillEnter(() => {
        if (closeMessage !== undefined) closeMessage()
    })

    React.useEffect(() => {
        fetchLockingSystems()

        const fetchAndSetItem = async (id: number) => {
            let include: string = ''

            if (segment === 'keys' && KeysList  !== undefined) {
                include = 'keys'
            } else if (segment === 'locks' && LocksList !== undefined) {
                include = 'locks'
            } else if (segment === 'locking-system-permissions' && LockingSystemPermissionsList !== undefined) {
                include = 'lockingSystemPermissions'
            } else if (segment === 'people' && PeopleList !== undefined) {
                include = 'people'
            }

            const result = itemType === 'LockingSystem'
                ? await items?.find((item: { id: number; }) => item.id === parseInt(itemId))
                : (
                    itemType === 'BlocklistKeys'
                        ? await fetchItemOnBlocklist(id, include)
                        : await fetchItem(id, include)
                );

            setItem(result)
        }

        if (parseInt(itemId) > 0) {
            fetchAndSetItem(parseInt(itemId))
        }

        let s = 'view'

        if (   (segment === 'form'                       && ItemForm  !== undefined)
            || (segment === 'keys'                       && KeysList  !== undefined)
            || (segment === 'locks'                      && LocksList !== undefined)
            || (segment === 'locking-system-permissions' && LockingSystemPermissionsList !== undefined)
            || (segment === 'locking-system-zones'       && LockingSystemZonesList !== undefined)
            || (segment === 'people'                     && PeopleList !== undefined)
            || (segment === 'data-source-syncs'          && DataSourceSyncList !== undefined)
            || (segment === 'time-limit-data'            && TimeLimitDataList !== undefined)
        ) {
            s = segment
        }

        setSelectedSegment(s)
    }, [items, itemId, itemType, segment])

    let
        pageContent,
        pageItemType:   string  = 'view',
        buttonAddShow:  boolean = false,
        buttonAddId:    string  = 'button-add-id',
        showButtonEdit: boolean = false,
        showButtonSave: boolean = false

    pageHeaderTitle = pageHeaderTitle || itemTypeName

    //if (items !== undefined) {
    if (item !== undefined || 1 === 1) {

        if (itemId === 'new') {
            pageHeaderTitle = itemTypeName + ' ' + t('common.add').toLowerCase()
            pageItemType    = 'new'
            pageContent     = <ItemForm item={item} />
            showButtonSave  = true
        } else if (selectedSegment === 'form' && item !== undefined) {
            pageHeaderTitle = itemTypeName + ' ' + t('common.edit').toLowerCase()
            pageItemType    = 'edit'

            pageContent = itemType === 'BlocklistKeys'
                ? <ItemForm item={item.key} blocklistItem={item} />
                : <ItemForm item={item} />;

            showButtonSave  = true

        } else if (item === undefined) {

            //console.log('message:', message)

            // if (message?.type === 'error') {
            //     pageHeaderTitle = itemTypeName
            //     pageItemType    = 'error'
            //
            //     pageContent = undefined !== ItemNotFound
            //          ? <ItemNotFound />
            //          : <div className="ion-padding">404 Not Found</div>
            // }

        } else if (selectedSegment === 'keys') {
            pageHeaderTitle = t('keys.title_list').toString()
                + ' ' + t('common.of').toString() + ' ' + itemTypeName.toLowerCase()
            pageItemType    = 'keys'
            // pageContent     = <KeysList item={item} keys={item.keys} />

            pageContent = <KeysList item={item} />

        } else if (selectedSegment === 'locks') {
            pageHeaderTitle = t('locks.title_list').toString()
                + ' ' + t('common.of').toString() + ' ' + itemTypeName.toLowerCase()
            pageItemType    = 'locks'
            pageContent = <LocksList item={item} />

            // pageContent = <LocksList item={item} locks={item?.locks}/>

        } else if (selectedSegment === 'locking-system-permissions') {

            pageHeaderTitle = t('locking-system-permissions.title_list').toString()
                + ' ' + t('common.of').toString() + ' ' + itemTypeName.toLowerCase()
            pageItemType    = 'lockingSystemPermissions'

            pageContent     = <LockingSystemPermissionsList item={itemType === 'BlocklistKeys' ? item.key : item} />

        } else if (selectedSegment === 'locking-system-zones') {

            pageHeaderTitle = t('locking-system-zones.title_list').toString()
            pageItemType = 'lockingSystemZones'

            pageContent = <LockingSystemZonesList item={itemType === 'BlocklistKeys' ? item.key : item} />

        } else if (selectedSegment === 'people') {
            pageHeaderTitle = t('people.title_list').toString()
            pageItemType    = 'people'
            pageContent     = <PeopleList item={item} />
        } else if (selectedSegment === 'data-source-syncs') {
            pageHeaderTitle = t('data-source-syncs.title_list').toString()
            pageItemType = 'data-source-syncs'
            pageContent = <DataSourceSyncList item={item}/>
        } else if (selectedSegment === 'time-limit-data') {
            pageHeaderTitle = t('time-limit-data.title_list').toString()
            pageItemType = 'time-limit-data'
            pageContent = <TimeLimitDataList item={item}/>
        } else {
            pageContent    = <ItemView item={item} />
            showButtonEdit = ItemForm !== undefined

            // No edit for items from a dataSource
            // if ((itemType === 'Person' || itemType === 'User')
            //     && item.dataSourceId !== undefined && item.dataSourceId !== null) {
            //     showButtonEdit = false
            // }

            // No edit for not account admins
            if (itemType === 'LockingSystemPermission' && ! isAccountAdmin()) {
                showButtonEdit = false
            }
        }

        if (segment === 'locking-system-permissions' &&
            (itemType === 'KeysInUse' || itemType === 'Lock'
             || itemType === 'PersonGroup' || itemType === 'User')
        ) {
            buttonAddShow = true

            if (itemType === 'KeysInUse')   buttonAddId = 'select-key-locking-system-permissions'
            if (itemType === 'Lock')        buttonAddId = 'select-lock-locking-system-permissions'
            if (itemType === 'PersonGroup') buttonAddId = 'select-person-group-locking-system-permissions'
            if (itemType === 'User')        buttonAddId = 'select-user-locking-system-permissions'
        }
    }

    let style: CSSProperties = inProgress ? { 'opacity': 0.4, 'filter': 'grayscale(100%)' } : {}

    return (
        <IonPage className={"page-item page-item-" + pageItemType}>
            <ItemPageHeader
                inProgress={inProgress}
                itemId={item?.id}
                itemTypeName={itemTypeName}
                itemType={itemType}
                itemTypeUrl={itemTypeUrl}
                pageHeaderTitle={pageHeaderTitle}
                buttonAddShow={buttonAddShow}
                buttonAddId={buttonAddId}
                showButtonEdit={showButtonEdit}
                showButtonSave={showButtonSave}
            />
            <IonContent forceOverscroll={false}>
                <div className="pageContentContainer">
                    <div className="maxWidth" style={style}>
                        {inProgress && <IonProgressBar type="indeterminate"></IonProgressBar>}

                        {inProgress && parseInt(itemId) > 0 && item === undefined &&
                            <div className="ion-padding-vertical ion-text-center">
                                {t('common.please_wait')}
                            </div>
                        }

                        {! inProgress && <div style={{ 'width': '100%', 'height': '4px' }}>&nbsp;</div>}
                        {message && <Message message={message} onClose={closeMessage} />}
                        {pageContent}
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default PageItem